import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.scss']
})
export class ProfileAvatarComponent implements OnInit {

  @Input('avatarClass') avatarClass: string = 'profile-icon-sm';
  @Input('profilePic') profilePic: string = '';
  @Input('figureClass') figureClass: string = '';
  @Input('name') name: string = '';

  constructor() { }

  /**
   * Angular lifecycle hook that is called after data-bound properties are initialized.
   */
  ngOnInit() {
  }

}
